import { Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges,HostBinding,AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import {CalendarService} from '../../services/calender.service';

import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
declare var $:any;
import * as moment from 'moment';
import {IRule} from '../../irule';


@Component({
  selector: 'event_calender',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './event_calender.component.html',
  styleUrls: ['./event_calender.component.css']
})
export class EventCalenderComponent extends BaseComponent implements OnInit ,AfterViewInit,OnDestroy,IRule{




   userName='';

   navigationsType=[];

   notification:any=[]

    msg:any;

    toastr:any;

    homeservice:any;

    _router:any;

    months:Array<any> = [];
    month_with_years:Array<string> = [];
    years:Array<any> = [];
    currMonth:any;
    currYear:any;

    msgSubscription:Subscription;

    newsletters:any = [];

    calsv:any;

    user:any;

    @HostBinding('style.width') public width: string = '100%';

    permissions:any=[];


    constructor( calsv:CalendarService,msg:MessageService, toastr: ToastrService,homeservice:HomeService , _router: Router){

        super(msg,toastr,homeservice,_router);


        this.newsletters = [];

        this.msg = msg;
        this.toastr = toastr;
        this.homeservice = homeservice;
        this._router =_router;
        this.calsv =calsv;







        this.msgSubscription = this.msg.getMessage().subscribe( (e) =>{


             if(e!=undefined){

              switch(e.text.type){


                case 'resetNewsLetter':

                    this.newsletters = [];



                break;

                case 'event_calander_update':


                try{


                  let nIndex:number = e.text.records.newsletter.index;

                  let nindexU:number=   this.newsletters.findIndex( (elem)=> { return elem.month == e.text.records.month && elem.year ==e.text.records.year })


                  let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

                  if(!tokenA) throw 'Error in parse';

                  if(!JSON.parse(tokenA)) throw 'Error in json parse';

                  tokenA = JSON.parse(tokenA);




                  calsv.add_update_newsltter_to_calender
                  ({
                  'token':tokenA.token,
                  'details':{
                             id:e.text.records.newsletter.id,
                             deadline:e.text.records.newsletter.deadline,
                             publish:e.text.records.newsletter.publish,
                             number:e.text.records.newsletter.number,
                             name:e.text.records.newsletter.name,
                             description:e.text.records.newsletter.description,
                             invite:e.text.records.newsletter.invite,
                             invitenow:'true'
                            },

                  }).subscribe( (evt)=>{

                       if(evt.status =='success'){

                         this.toastr.success('Newsletter invite sent successfully', '', {timeOut: 3000});




                          this.newsletters[nindexU]['newsletters'][nIndex] = {
                            id:evt.id,
                            deadline:e.text.records.newsletter.deadline,
                            publish:e.text.records.newsletter.publish,
                            number:e.text.records.newsletter.number,
                            name:e.text.records.newsletter.name,
                            description:e.text.records.newsletter.description,
                            invite:e.text.records.newsletter.invite
                        };


                       } else{

                       //  this.toastr.error('Something went wrong', '', {timeOut: 3000});
                         this._router.navigate(['/login']);

                       }


                  });






                }catch(error){


                  this.toastr.error( error , '', {timeOut: 3000});
                  this._router.navigate(['/login']);

                }









                break;


                case 'event_calander_add':


                   try{




                    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

                    if(!tokenA) throw 'Error in parse';

                    if(!JSON.parse(tokenA)) throw 'Error in json parse';

                    tokenA = JSON.parse(tokenA);





                let nindex:number=   this.newsletters.findIndex( (elem)=> { return elem.month == e.text.records.month && elem.year ==e.text.records.year })

                if(nindex !=-1){



                   calsv.add_update_newsltter_to_calender
                               ({
                               'token':tokenA.token,
                               'details':{
                                          deadline:e.text.records.newsletter.deadline,
                                          publish:e.text.records.newsletter.publish,
                                          number:e.text.records.newsletter.number,
                                          name:e.text.records.newsletter.name,
                                          description:e.text.records.newsletter.description,
                                          invite:e.text.records.newsletter.invite
                                         },

                               }).subscribe( (evt)=>{

                                    if(evt.status =='success'){

                                      this.toastr.success('Newsletter created', '', {timeOut: 3000});

                                       let rec= e.text.records.newsletter;

                                       rec.id = evt.id;

                                       this.newsletters[nindex]['newsletters'].unshift(rec);


                                    } else{

                                      //this.toastr.error('Something went wrong', '', {timeOut: 3000});
                                      this._router.navigate(['/login']);

                                    }


                               });







                }else{




                  calsv.add_update_newsltter_to_calender
                  ({
                  'token':tokenA.token,
                  'details':{
                             deadline:e.text.records.newsletter.deadline,
                             publish:e.text.records.newsletter.publish,
                             number:e.text.records.newsletter.number,
                             name:e.text.records.newsletter.name,
                             description:e.text.records.newsletter.description,
                             invite:e.text.records.newsletter.invite
                            },

                  }).subscribe( (evt)=>{

                       if(evt.status =='success'){

                         this.toastr.success('Newsletter created', '', {timeOut: 3000});


                          let rec= e.text.records.newsletter;

                          rec.id = evt.id;

                          this.newsletters.push(  {  month:e.text.records.month,
                            year:e.text.records.year,
                            newsletters:[rec]

                          })


                       } else{

                        // this.toastr.error('Something went wrong', '', {timeOut: 3000});
                         this._router.navigate(['/login']);

                       }


                  });






                }

              }catch(e){


               // this.toastr.error('Something went wrong', '', {timeOut: 3000});
                this._router.navigate(['/login']);


              }

                 break;



              }


             }





        });



    }


    ngAfterViewInit(){

     window.scrollTo(0,0);

    }



    get_months(edate:any){

      // console.log('edate',edate)

      try{

      this.months=[];
      this.month_with_years=[];
      this.years=[];


      let current = moment(edate).format('MMM YYYY');

      // console.log('current',current);


      let prev_month_1 =moment(edate).subtract(1,'months').endOf('month').format('MMM YYYY');

      //let prev_month_2 =moment(edate).subtract(2,'months').endOf('month').format('MMM YYYY');

      let next_month_1 =moment(edate).add(1,'months').endOf('month').format('MMM YYYY');

     // let next_month_2 =moment(edate).add(2,'months').endOf('month').format('MMM YYYY');

     // let next_month_3 =moment(edate).add(3,'months').endOf('month').format('MMM YYYY');



     // this.months.push(moment(edate).subtract(2,'months').endOf('month').format('MM'));
      this.months.push(moment(edate).subtract(1,'months').endOf('month').format('MM'));
      this.months.push(moment(edate).format('MM'));

      this.months.push(moment(edate).add(1,'months').endOf('month').format('MM'));
      //this.months.push(moment(edate).add(2,'months').endOf('month').format('MM'));
     // this.months.push(moment(edate).add(3,'months').endOf('month').format('MM'));

     // this.month_with_years.push(prev_month_2);
      this.month_with_years.push(prev_month_1);
      this.month_with_years.push(current);

      this.month_with_years.push(next_month_1);
     // this.month_with_years.push(next_month_2);
    //  this.month_with_years.push(next_month_3);


      //this.years.push(moment(edate).subtract(2,'months').endOf('month').format('YYYY'));
      this.years.push(moment(edate).subtract(1,'months').endOf('month').format('YYYY'));
      this.years.push(moment(edate).format('YYYY'));

      this.years.push(moment(edate).add(1,'months').endOf('month').format('YYYY'));
     // this.years.push(moment(edate).add(2,'months').endOf('month').format('YYYY'));
    //  this.years.push(moment(edate).add(3,'months').endOf('month').format('YYYY'));



      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

        if(!tokenA) throw 'Error in parse';

        if(!JSON.parse(tokenA)) throw 'Error in json parse';

        tokenA = JSON.parse(tokenA);


       // list_newsltters_from_calender({'token':tokenA.token,'details':{'from':,'to':}}).

       let m1 =this.months[0];
       let m2 =this.months[this.months.length -1];


       let from =this.years[0]+'-'+m1;

       let to =this.years[this.years.length -1]+'-'+m2;



       this.calsv.list_newsltters_from_calender({'token':tokenA.token,'details':{'from':from,'to':to ,'order':'publish desc'}}).subscribe((evt)=>{




          if(evt.status=='success'){


            this.user =evt.user;

            this.navigationsType=evt.navigation;

            this.userName=evt.user.name;
            this.notification = evt.notification

            this.broadcast_menu();


            if(evt.calendar.length > 0){



              this.permissions =evt.permission;


              this.newsletters =evt.calendar;



            }

          }else{

            //this.toastr.error('Something went wrong', '', {timeOut: 3000});
            this._router.navigate(['/login']);

          }

       });






      }catch(exc){

      //  this.toastr.error('Something went wrong', '', {timeOut: 3000});
        this._router.navigate(['/login']);


      }


    }



    broadcast_menu(){


      this.msg.sendMessage({'user':this.userName,'type':'left_menu_link','navigations':this.navigationsType,'notification':this.notification});


    }

    ngOnInit(){

      window.scrollTo(0, 0);


        this.get_months(new Date());

        this.currMonth =new Date().getMonth();
        this.currYear = new Date().getFullYear();


    }


    nextMonthCycle(){


      var now = new Date();



      // if (now.getMonth() == 0) {
        if(this.currMonth == 11){

          // this.currMonth=0;

          this.currMonth= 2;

          // var current = new Date(now.getFullYear() + 1, this.currMonth, 1);

          var current = new Date(this.currYear + 1, this.currMonth, 1);

          this.currYear = this.currYear +1;


      } else {


          this.currMonth=this.currMonth + 3;

          // var current = new Date(now.getFullYear(),  this.currMonth, 1);

          var current = new Date(this.currYear,  this.currMonth, 1);



      }


      this.get_months(current);


    }


    prevMonthCycle(){


      var now = new Date();


      // if (now.getMonth() == 0) {
        if(this.currMonth == 0){

          this.currMonth = 11;

          // var current = new Date(now.getFullYear() - 1, this.currMonth, 1);
          var current = new Date( this.currYear - 1, this.currMonth, 1);

          this.currYear =  this.currYear -1;


      } else {
          this.currMonth = this.currMonth -3;
          var current = new Date( this.currYear, this.currMonth , 1);

      }

      this.get_months(current);

    }

    ngOnDestroy(){


      this.msg.sendMessage({'type':'resetNewsLetter' });


      this.msgSubscription.unsubscribe();


    }


}
